export default __webpack_public_path__ + "87f730d05f0fb9e7d98019ecf93862d3.svg";